import React,{useState,useEffect} from "react";
import {format} from 'date-fns';
import styled from 'styled-components';
import theme from './../theme';
import DatePicker,  { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import "react-datepicker/dist/react-datepicker.css";
registerLocale("es", es);

const formatearFecha = (fecha = new Date()) => {
    return format((fecha), "EE dd 'de' MMMM 'de' yyyy 'a las' HH:mm", {locale: es});
}

const ContenedorInput = styled.div`
    position: relative;
    border-radius: 10px;
    height: 2.5rem; /* 80px */
    input {
        height: 2.5rem; /* 80px */
        font-family: 'Work Sans', sans-serif;
        box-sizing: border-box;
        border: none;
        border-bottom: 2px solid ${theme.grisClaro2};
        border-radius: 10px;
        cursor: pointer;
        text-transform: uppercase;
        width: 100%;
        padding: 0 1.25rem; /* 20px */
        font-size: 1rem; /* 24px */
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        outline: none;
        &:hover {
            background: ${theme.grisClaro};
        }
    }
 
    .rdp {
        position: absolute;
    }
 
    .rdp-months {
        display: flex;
        justify-content: center;
    }
 
    .rdp-month {
        background: #fff;
        box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
        padding: 20px;
        border-radius: 10px;
    }
 
    @media (max-width: 60rem) {
        /* 950px */
        & > * {
            width: 100%;
        }
    }
`;

const  DateTimePicker = ({fechahoraviaje, cambiarFechahoraviaje}) => {
    const[visible,cambiaVisible] = useState(false);
    const[fechaFormateada,cambiafechaFormateada] = useState();


    const handleChange = (e) => {
        cambiarFechahoraviaje(e);
        
      };
    
     /* const handleClick = (e) => {
        e.preventDefault();
        cambiaVisible(!visible);
        if (fechahoraviaje === 'Ingrese Fecha y hora de Viaje')
        {cambiarFechahoraviaje(new Date())}
      };    

    const handleOnBlur = (e) => {
        e.preventDefault();
        cambiaVisible(!visible);
      };
    */
  useEffect (()=>{    
        if (fechahoraviaje !== null)
        {cambiafechaFormateada(formatearFecha(fechahoraviaje))}
        else
        {cambiafechaFormateada(fechahoraviaje)}
    },[fechahoraviaje]);  



    
    
    
      return (
    <ContenedorInput >
        <DatePicker 
        placeholderText="Ingrese Fecha y hora de Viaje"
        selected={fechahoraviaje}
        onChange={handleChange}
        locale="es"
        timeInputLabel="Hora:"
        dateFormat="EE dd 'de' MMMM 'de' yyyy 'a las' HH:mm"
        showTimeInput
        withPortal
        shouldCloseOnSelect={false}
        />
    </ContenedorInput>
    



    
        )
}
 
export default  DateTimePicker;